import { combineReducers } from 'redux';

// ------------------------------------------
// DNK CMS Reducers:
// ------------------------------------------
import pagesReducer from './pages/reducer';
import attributesReducer from './attributes-sets/reducer';
import templatesReducer from './templates/reducer';
import templatePreviewsReducer from './template-previews/reducer';
import formsReducer from './forms/reducer';
import productsReducer from './products/reducer';
import guideReducer from './guide/reducer';
import authReducer from './auth/reducer';
import adminsReducer from './admins/reducer';
import customModulesReducer from './custom-modules/reducer';
// @deprecated
// import catalogReducer from './catalog/reducer';
import blocksReducer from './blocks/reducer';
import ordersReducer from './orders/reducer';
import orderStatusesReducer from './order-statuses/reducer';
import orderStatusMapsReducer from './order-status-maps/reducer';
import orderTriggersReducer from './order-triggers/reducer';
import markersReducer from './markers/reducer';
import settingsReducer from './settings/reducer';
import permissionsReducer from './permissions/reducer';
import authPermissionsReducer from './auth-permissions/reducer';
import journalReducer from './journal/reducer';
import journalTrafficReducer from './journal-traffic/reducer';
import journalContentApiReducer from './journal-content-api/reducer';
import journalContentApiErrorsReducer from './journal-content-api-errors/reducer';
import productStatusesReducer from './product-statuses/reducer';
import typesReducer from './types/reducer';
import menusReducer from './menus/reducer';
import filtersReducer from './filters/reducer';
import blockersReducer from './blockers/reducer';
import usersReducer from './users/reducer';
import userGroupsReducer from './user-groups/reducer';
import usersPermissionReducer from './user-group-permissions/reducer';
import localesReducer from './locales/reducer';
import certsReducer from './certs/reducer';
import tokensReducer from './tokens/reducer';
import paymentsReducer from './payments/reducer';
import eventsReducer from './events/reducer';
import usersAuthProviderReducer from './users-auth-providers/reducer';
import importCatalogReducer from './import-catalog/reducer';
import importDataReducer from './import-data/reducer';
import navigateReducer from './navigate/reducer';
import collectionsReducer from './collections/reducer';
import discountsReducer from './discounts/reducer';
import tableProcessesReducer from './table-processes/reducer';
import bonusBalanceReducer from './bonus-balance/reducer';
import chatReducer from './chat/chatSlice';
import slidesReducer from './slides/reducer';
import aiHistoryReducer from './ai-history/reducer';
import mcpAgentReducer from './mcp-agent/agentSlice';

const Reducers = combineReducers({
  pagesReducer,
  attributesReducer,
  templatesReducer,
  templatePreviewsReducer,
  formsReducer,
  productsReducer,
  guideReducer,
  authReducer,
  adminsReducer,
  customModulesReducer,
  blocksReducer,
  markersReducer,
  settingsReducer,
  permissionsReducer,
  authPermissionsReducer,
  journalReducer,
  journalTrafficReducer,
  journalContentApiReducer,
  journalContentApiErrorsReducer,
  productStatusesReducer,
  typesReducer,
  menusReducer,
  filtersReducer,
  blockersReducer,
  usersReducer,
  localesReducer,
  certsReducer,
  tokensReducer,
  userGroupsReducer,
  paymentsReducer,
  usersPermissionReducer,
  eventsReducer,
  ordersReducer,
  orderStatusesReducer,
  orderStatusMapsReducer,
  orderTriggersReducer,
  usersAuthProviderReducer,
  importCatalogReducer,
  importDataReducer,
  navigateReducer,
  collectionsReducer,
  discountsReducer,
  tableProcessesReducer,
  bonusBalanceReducer,
  chatReducer,
  slidesReducer,
  aiHistoryReducer,
  mcpAgentReducer,
});

export default Reducers;
